<template>
  <div class="content">
    <div class="loading-container" v-if="loading">
      <a-spin />
    </div>

    <a-row :gutter="16" v-for="post in posts" :key="post.title" v-else>
      <a-divider class="content" orientation="left">{{post.created_at.fromNow()}}</a-divider>

      <router-link :to="'/devlog/post/'+post.id" class="blog-post-row">
        <a-col :sm="{span: 12}" :lg="{span: 6}">
          <a-card :ref="'post-card'+post.id">
            <img src :id="post.id" slot="cover" alt class />
          </a-card>
        </a-col>
        <a-col :sm="{span: 12}" :lg="{span: 10}">
          <span class="game-title">{{post.game}}</span>
          <h1>{{post.title}}</h1>
          <p>{{post.details}}</p>
        </a-col>
      </router-link>
    </a-row>
  </div>
</template>

<script>
import firebase from "@/configs/firebase-setup";
import moment from "moment";
const db = firebase.firestore();
const storage = firebase.storage().ref();

export default {
  data() {
    return {
      loading: false,
      posts: []
    };
  },

  mounted() {
    this.getPosts();
  },

  updated() {
    this.posts.forEach(post => {
      this.getPostImgURL(post.id);
    });
  },

  methods: {
    async getPosts() {
      try {
        this.loading = true;

        const snapshot = await db
          .collection("posts")
          .orderBy("created_at", "desc")
          .get();

        snapshot.forEach(doc => {
          const data = doc.data();

          if (data.publishDate == null) {
            return;
          }

          data.id = doc.id;
          data.created_at = moment(data.created_at);

          this.posts.push(data);
        });

        this.posts.sort((a, b) => {
          return a.created_at;
        });

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    getPostImgURL(postId) {
      storage
        .child(`images/posts/${postId}/${postId}`)
        .getDownloadURL()
        .then(url => {
          const img = document.getElementById(postId);
          img.src = url;
        })
        .catch(err => {
          console.log(err);
          return "";
        });
    }
  }
};
</script>


<style scoped>
.loading-container {
  text-align: center;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
}

.blog-post-row {
  color: #383838;
}

.content {
  padding: 0 50px 30px 50px;
  font-family: "ZCOOL QingKe HuangYou", cursive;
  font-size: 1.2em;
}

.game-title {
  color: #afaeae;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
